import url from 'url';
import { Component } from 'react';
import PropTypes from 'prop-types';
import omit from 'lodash/omit';
import get from 'lodash/get';
import { withRouter } from 'react-router-dom';
import { LocationAndLocalizationContext } from '../providers/LocationAndLocalizationProvider';

const EMBED_FAVORITE_QUERY = 'embedfavorite';

export default function withEmbedFavoriteCheck(ComponentToDecorate) {
  class EmbedFavoriteCheck extends Component {
    static propTypes = {
      isFollowing: PropTypes.bool.isRequired,
      handleFavoriteToggle: PropTypes.func.isRequired,
      history: PropTypes.object.isRequired,
    };

    static contextType = LocationAndLocalizationContext;

    componentDidMount() {
      const query = get(this.context, 'location.query', {});
      const favoriteFromEmbed = get(query, EMBED_FAVORITE_QUERY);
      if (favoriteFromEmbed !== 'true') {
        return;
      }
      const { isFollowing, handleFavoriteToggle, history } = this.props;
      // If the user is not currently following then favorite the profile
      if (!isFollowing) {
        handleFavoriteToggle();
      }
      // Remove the embed query parameter from the location
      // and replace the route so that the browser history
      // url does not contain the embedfavorite query.
      const updated = omit(query, [EMBED_FAVORITE_QUERY]);
      const location = {
        ...this.context.location,
        query: {
          ...updated,
        },
      };

      history.replace(url.format(location));
    }

    render() {
      return <ComponentToDecorate {...this.props} />;
    }
  }
  return withRouter(EmbedFavoriteCheck);
}
